"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClient = void 0;
var axios_1 = __importDefault(require("axios"));
var csrf_1 = require("./csrf");
var ApiClient = /** @class */ (function () {
    function ApiClient(_a) {
        var _b = _a === void 0 ? {} : _a, baseUrl = _b.baseUrl, _c = _b.baseOptions, baseOptions = _c === void 0 ? {} : _c, csrfCookieOptions = _b.csrfCookieOptions, cookieOverrides = _b.cookieOverrides;
        this.baseUrl = this.validateBaseUrl(baseUrl);
        this.baseOptions = baseOptions;
        this.csrfCookieOptions = csrfCookieOptions;
        this.cookieOverrides = this.validateCookieOverrides(cookieOverrides);
    }
    ApiClient.prototype.get = function (path, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.get(this.getUrl(path), this.getOptions(options))];
            });
        });
    };
    ApiClient.prototype.post = function (path, data, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.post(this.getUrl(path), data, this.getOptions(options))];
            });
        });
    };
    ApiClient.prototype.put = function (path, data, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.put(this.getUrl(path), data, this.getOptions(options))];
            });
        });
    };
    ApiClient.prototype.patch = function (path, data, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.patch(this.getUrl(path), data, this.getOptions(options))];
            });
        });
    };
    ApiClient.prototype.delete = function (path, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.delete(this.getUrl(path), this.getOptions(options))];
            });
        });
    };
    ApiClient.prototype.request = function (method, path, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios_1.default.request(__assign({ url: this.getUrl(path), method: method }, this.getOptions(options)))];
            });
        });
    };
    ApiClient.prototype.getBaseUrl = function () {
        return this.baseUrl;
    };
    ApiClient.prototype.getOptions = function (requestOptions) {
        if (requestOptions === void 0) { requestOptions = {}; }
        var csrfToken = this.getCsrfToken();
        var headers = __assign(__assign({ 'X-CSRF': csrfToken, 
            // This enables the API over HTTP so browsers without CORS can use it.
            'X-ALLOW-HTTP': true, 
            // Identifies this request for API stat purposes.
            'Api-Client': 'iFixit-Web', 'content-type': 'application/json' }, this.baseOptions.headers), requestOptions.headers);
        var cookieOverrideString = this.getCookieOverrideString(csrfToken);
        if (cookieOverrideString) {
            headers.cookie = cookieOverrideString;
        }
        return __assign(__assign(__assign({}, this.baseOptions), requestOptions), { 
            // Do this after spreading options so that the default headers aren't overwritten if
            // additional headers are set
            headers: headers });
    };
    ApiClient.isApiError = function (error) {
        return axios_1.default.isAxiosError(error);
    };
    ApiClient.isInvalidLoginError = function (error) {
        var _a;
        return ApiClient.isApiError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401;
    };
    ApiClient.isForbiddenError = function (error) {
        var _a;
        return ApiClient.isApiError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 403;
    };
    ApiClient.isNotFoundError = function (error) {
        var _a;
        return ApiClient.isApiError(error) && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404;
    };
    ApiClient.shouldRedirectError = function (error) {
        return ApiClient.isForbiddenError(error);
    };
    ApiClient.prototype.getUrl = function (path) {
        // Remove leading slash if it exists
        path = path.replace(/^\//, '');
        return new URL("./api/2.0/".concat(path), this.baseUrl).toString();
    };
    ApiClient.prototype.getCsrfToken = function () {
        return (0, csrf_1.getCsrfCookie)() || (0, csrf_1.refreshCsrfCookie)(this.csrfCookieOptions);
    };
    ApiClient.prototype.getCookieOverrideString = function (csrfToken) {
        if (this.cookieOverrides) {
            // Ensure that the csrf cookie is set when overriding the cookie header
            var cookieString = "".concat(csrf_1.CSRF_COOKIE_NAME, "=").concat(csrfToken, ";");
            for (var cookieName in this.cookieOverrides) {
                cookieString += " ".concat(cookieName, "=").concat(this.cookieOverrides[cookieName], ";");
            }
            return cookieString;
        }
        return null;
    };
    ApiClient.prototype.validateBaseUrl = function (baseUrl) {
        if (typeof window !== 'undefined') {
            return baseUrl || window.location.origin;
        }
        else if (!baseUrl) {
            throw new Error('ApiClient must be initialized with a baseUrl when used server side.');
        }
        return baseUrl;
    };
    ApiClient.prototype.validateCookieOverrides = function (cookieOverrides) {
        if (typeof window !== 'undefined' && cookieOverrides) {
            throw new Error('ApiClient can only override cookies when used server side.');
        }
        return cookieOverrides;
    };
    return ApiClient;
}());
exports.ApiClient = ApiClient;
